module.exports = __webpack_public_path__ + "static/podcast-app-cover-fd6a2b8d37a10c67e51dc4145f439a90.png";